import { Modal } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";

function SyncModal({
  show,
  title = "Sync in Progress...",
  status = "new",
  onHide,
}) {
  const safeStatus = String(status || "new").toLowerCase();

  const getTitle = () => {
    switch (safeStatus) {
      case "completed":
        return "Sync Completed";
      case "error":
        return "Sync Failed";
      case "retry":
        return "Retrying Sync...";
      default:
        return title;
    }
  };

  const getMessage = () => {
    switch (safeStatus) {
      case "completed":
        return "All data has been synchronized successfully.";
      case "error":
        return "An error occurred during synchronization. Please try again.";
      case "retry":
        return "Retrying synchronization. Please wait...";
      default:
        return "This process may take a few moments. You can close this dialog and continue working - the synchronization will continue in the background.";
    }
  };

  const renderStatusIcon = () => {
    switch (safeStatus) {
      case "completed":
        return <FaCheck className="text-success" size={40} />;
      case "error":
      case "retry":
        return <FaTimes className="text-danger" size={40} />;
      default:
        return (
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        );
    }
  };

  return (
    <Modal
      show={show}
      size="md"
      centered
      backdrop={true}
      keyboard={true}
      onHide={onHide}
    >
      <Modal.Header className="border-0 justify-content-center" closeButton>
        <Modal.Title className="text-center">{getTitle()}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <div className="d-flex justify-content-center align-items-center mb-3">
          {renderStatusIcon()}
        </div>
        <p className="text-muted mb-0 mt-5" style={{ fontSize: "0.9rem" }}>
          {getMessage()}
        </p>
      </Modal.Body>
    </Modal>
  );
}

export default SyncModal;
